<app-side-menu>
  <div class="srd-wrap">
    <!-- Estados iniciais -->
    <div *ngIf="isLoading" class="srd-state">
      <i class="fas fa-spinner fa-spin"></i>
      <span>Carregando solicitação…</span>
    </div>

    <div *ngIf="error && !isLoading" class="srd-alert srd-alert--danger">
      {{ error }}
    </div>

    <ng-container *ngIf="!isLoading && requestDetail">
      <!-- Cabeçalho fixo / ações -->
      <header class="srd-header">
        <div class="srd-header__left">
          <button type="button" class="srd-btn srd-btn--ghost" (click)="goBack()">
            <i class="fas fa-chevron-left"></i>
            Voltar
          </button>
          <span class="srd-header__rule" aria-hidden="true"></span>
          <div>
            <h1 class="srd-title">
              Atendimento de solicitação
              <span class="srd-badge-os">OS #{{ requestDetail.serviceOrderNumber || requestDetail.serviceOrderId }}</span>
            </h1>
          </div>
        </div>
        <div class="srd-header__actions">
          <button
            type="button"
            class="srd-btn srd-btn--reject"
            (click)="rejeitarPedido()"
            [disabled]="!canRejeitarPedido() || isUpdatingPedidoStatus">
            <i class="fas fa-times-circle" *ngIf="!isUpdatingPedidoStatus"></i>
            <i class="fas fa-spinner fa-spin" *ngIf="isUpdatingPedidoStatus"></i>
            Rejeitar pedido
          </button>
          <button
            *ngIf="!isPedidoAguardandoRetirada()"
            type="button"
            class="srd-btn srd-btn--primary"
            (click)="atenderPedido()"
            [disabled]="!canAtenderPedido() || isUpdatingPedidoStatus">
            <i class="fas fa-box-open" *ngIf="!isUpdatingPedidoStatus"></i>
            <i class="fas fa-spinner fa-spin" *ngIf="isUpdatingPedidoStatus"></i>
            Atender pedido
          </button>
          <button
            *ngIf="isPedidoAguardandoRetirada()"
            type="button"
            class="srd-btn srd-btn--success"
            (click)="confirmarAtendimentoPedido()"
            [disabled]="!canConfirmarAtendimentoPedido() || isUpdatingPedidoStatus">
            <i class="fas fa-check-circle" *ngIf="!isUpdatingPedidoStatus"></i>
            <i class="fas fa-spinner fa-spin" *ngIf="isUpdatingPedidoStatus"></i>
            Confirmar atendimento
          </button>
        </div>
      </header>

      <div class="srd-grid">
        <!-- Coluna esquerda -->
        <aside class="srd-aside">
          <div class="srd-card">
            <h3 class="srd-card__title">
              <i class="far fa-calendar-alt"></i>
              Resumo da solicitação
            </h3>
            <div class="srd-fields">
              <div class="srd-field">
                <span class="srd-field__label">Status atual</span>
                <span class="srd-pill srd-pill--amber">
                  <span class="srd-pill__dot"></span>
                  {{ translateStatus(requestDetail.status) }}
                </span>
              </div>
              <div class="srd-field">
                <span class="srd-field__label">Prioridade</span>
                <span class="srd-pill srd-pill--neutral">{{ requestDetail.priority || '—' }}</span>
              </div>
              <div class="srd-field">
                <span class="srd-field__label">Número do registo</span>
                <span class="srd-mono">{{ requestDetail.requestNumber }}</span>
              </div>
              <div class="srd-field">
                <span class="srd-field__label">Data da solicitação</span>
                <span class="srd-field__val">{{ formatarData(requestDetail.requestedAt) }}</span>
              </div>
              <div class="srd-field">
                <span class="srd-field__label">Observações</span>
                <p class="srd-notes">{{ requestDetail.notes || 'Sem observações registadas.' }}</p>
              </div>
            </div>
          </div>

          <div class="srd-card">
            <h3 class="srd-card__title">
              <i class="far fa-clock"></i>
              Histórico
            </h3>
            <div class="srd-timeline" *ngIf="requestDetail.history?.length; else noHist">
              <div class="srd-timeline__item" *ngFor="let h of requestDetail.history; trackBy: trackHistory">
                <span class="srd-timeline__dot"></span>
                <div class="srd-timeline__body">
                  <span class="srd-timeline__date">{{ formatarData(h.eventDate) }}</span>
                  <span class="srd-timeline__desc">{{ h.description || '—' }}</span>
                  <div class="srd-timeline__meta">
                    <span class="srd-timeline__tag">{{ translateEventType(h.eventType) }}</span>
                    <span class="srd-timeline__arrow">→</span>
                    <span class="srd-timeline__status">{{ translateStatus(h.toStatus) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noHist>
              <p class="srd-empty">Nenhum evento no histórico.</p>
            </ng-template>
          </div>
        </aside>

        <!-- Coluna direita -->
        <div class="srd-main">
          <div class="srd-card srd-card--flush">
            <div class="srd-items-head">
              <h3 class="srd-items-head__title">
                <i class="fas fa-cube"></i>
                Itens da solicitação
                <span class="srd-count">{{ requestDetail.items?.length || 0 }}</span>
              </h3>
            </div>
            <div class="srd-table-wrap">
              <table class="srd-table">
                <thead>
                  <tr>
                    <th>Item solicitado</th>
                    <th>Almoxarifado</th>
                    <th class="srd-th-center">Quantidades</th>
                    <th>Status / ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of requestDetail.items">
                    <td>
                      <div class="srd-item-name">{{ item.requestedStockName || ('Estoque #' + item.requestedStockId) }}</div>
                      <div class="srd-item-ids">
                        <span>ID: {{ item.serviceOrderStockRequestItemId }}</span>
                        <span>Ref: {{ item.requestedStockId }}</span>
                      </div>
                    </td>
                    <td>
                      <span class="srd-wh-pill">
                        <i class="fas fa-map-marker-alt"></i>
                        {{ item.sourceWarehouseName || ('#' + (item.sourceWarehouseId || '—')) }}
                      </span>
                    </td>
                    <td class="srd-td-center">
                      <div class="srd-qty-stack">
                        <div class="srd-qty-line">Solicitada: <strong>{{ item.requestedQuantity }}</strong></div>
                        <div class="srd-qty-rule"></div>
                        <div class="srd-qty-line srd-qty-line--ok">Atendida: <strong>{{ item.fulfilledQuantity || 0 }}</strong></div>
                      </div>
                    </td>
                    <td>
                      <div class="srd-action-cell">
                        <span class="srd-pill srd-pill--item-status">{{ translateStatus(item.status) }}</span>
                        <span class="srd-avail" *ngIf="canFulfillItem(item)">
                          <i class="fas fa-check-circle"></i>
                          Disponível p/ atendimento
                        </span>
                        <span class="srd-avail srd-avail--mute" *ngIf="!canFulfillItem(item)">
                          {{ isPedidoEmSeparacao() ? 'Não disponível' : 'Aguardando início do atendimento' }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Atendimento por item (só após Em Separação) -->
          <div class="srd-card srd-fulfill" *ngIf="requestDetail.items?.length && isPedidoEmSeparacao()">
            <h3 class="srd-card__title srd-card__title--lg">
              <i class="fas fa-dolly"></i>
              Atendimento por item
            </h3>

            <div class="request-item-portal srd-fulfill-item" *ngFor="let reqItem of requestDetail.items">
              <div class="request-item-portal-header srd-fulfill-item-head">
                <div class="srd-fulfill-item-title">
                  <strong>Item #{{ reqItem.serviceOrderStockRequestItemId }}</strong>
                  — {{ reqItem.requestedStockName || ('Estoque #' + reqItem.requestedStockId) }}
                </div>
                <div class="srd-fulfill-item-stats" aria-label="Totais do item">
                  <span>Solicitado: <strong>{{ reqItem.requestedQuantity }}</strong></span>
                  <span>Atendido: <strong>{{ reqItem.fulfilledQuantity || 0 }}</strong></span>
                  <span>Restante: <strong>{{ getRemainingQuantity(reqItem) }}</strong></span>
                  <span>Status: <strong>{{ translateStatus(reqItem.status) }}</strong></span>
                </div>
              </div>

              <div class="stock-portal srd-fulfill-block" *ngIf="canFulfillItem(reqItem)">
                <h5>Seleção de item no estoque</h5>
                <p class="srd-portal-intro">
                  <strong>Estoque:</strong> {{ reqItem.requestedStockName || ('Estoque #' + reqItem.requestedStockId) }}
                  (ID {{ reqItem.requestedStockId }})
                </p>

                <div class="stock-search srd-fulfill-search">
                  <input
                    type="text"
                    class="form-control"
                    [ngModel]="getPortalState(reqItem.serviceOrderStockRequestItemId).searchTerm"
                    (ngModelChange)="onStockSearchTermChange(reqItem, $event)"
                    [name]="'stockSearchTerm-' + reqItem.serviceOrderStockRequestItemId"
                    placeholder="Pesquisar por nome, código ou ID...">
                  <button type="button" class="btn btn-outline-primary" (click)="refreshStockItemsList(reqItem)">
                    <i class="fas fa-search me-1"></i>
                    Atualizar lista
                  </button>
                </div>

                <div *ngIf="getPortalState(reqItem.serviceOrderStockRequestItemId).loadingStockItems" class="srd-small-muted">
                  <i class="fas fa-spinner fa-spin me-1"></i>
                  Carregando itens do estoque…
                </div>

                <div
                  class="table-responsive mt-2"
                  *ngIf="!getPortalState(reqItem.serviceOrderStockRequestItemId).loadingStockItems && getPortalState(reqItem.serviceOrderStockRequestItemId).stockSearchResults.length > 0">
                  <table class="table table-sm table-bordered srd-inner-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Código</th>
                        <th>Qtd</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let stockItem of getPortalState(reqItem.serviceOrderStockRequestItemId).stockSearchResults"
                        [class.active-row]="getPortalState(reqItem.serviceOrderStockRequestItemId).selectedStockItem?.id === stockItem.id">
                        <td>{{ stockItem.id }}</td>
                        <td>{{ stockItem.name }}</td>
                        <td>{{ stockItem.code }}</td>
                        <td>{{ stockItem.quantity }}</td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-sm"
                            [ngClass]="getPortalState(reqItem.serviceOrderStockRequestItemId).selectedStockItem?.id === stockItem.id ? 'btn-success' : 'btn-primary'"
                            (click)="selectStockItem(reqItem.serviceOrderStockRequestItemId, stockItem)">
                            {{ getPortalState(reqItem.serviceOrderStockRequestItemId).selectedStockItem?.id === stockItem.id ? 'Selecionado' : 'Selecionar' }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  *ngIf="!getPortalState(reqItem.serviceOrderStockRequestItemId).loadingStockItems
                    && getPortalState(reqItem.serviceOrderStockRequestItemId).hasLoadedStockItems
                    && getPortalState(reqItem.serviceOrderStockRequestItemId).stockSearchResults.length === 0"
                  class="srd-small-muted">
                  Nenhum item encontrado para essa busca.
                </div>
              </div>

              <div class="srd-fulfill-form" *ngIf="canFulfillItem(reqItem)">
                <div class="form-group">
                  <label>Tipo de atendimento</label>
                  <select
                    class="form-select"
                    [ngModel]="getPortalState(reqItem.serviceOrderStockRequestItemId).fulfillmentType"
                    (ngModelChange)="onFulfillmentTypeChange(reqItem, $event)">
                    <option value="Total">Total</option>
                    <option value="Parcial">Parcial</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Item selecionado</label>
                  <div class="readonly-value">
                    {{ getPortalState(reqItem.serviceOrderStockRequestItemId).selectedStockItem?.name || 'Nenhum item selecionado' }}
                  </div>
                </div>
                <div class="form-group">
                  <label>Quantidade</label>
                  <input
                    type="number"
                    class="form-control"
                    min="1"
                    [max]="getRemainingQuantity(reqItem)"
                    [ngModel]="getPortalState(reqItem.serviceOrderStockRequestItemId).quantity"
                    (ngModelChange)="onQuantityChange(reqItem, $event)">
                  <small class="text-muted">Máx.: {{ getRemainingQuantity(reqItem) }}.</small>
                </div>
                <div class="form-group">
                  <label>Almoxarifado de origem</label>
                  <div class="readonly-value">
                    {{ reqItem.sourceWarehouseName || ('ID ' + (reqItem.sourceWarehouseId || '—')) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="srd-fulfill-actions">
              <button
                type="button"
                class="srd-btn srd-btn--success"
                (click)="confirmBatchFulfillment()"
                [disabled]="isSubmittingBatch">
                <i class="fas fa-spinner fa-spin me-1" *ngIf="isSubmittingBatch"></i>
                <i class="fas fa-check me-1" *ngIf="!isSubmittingBatch"></i>
                Confirmar atendimento
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</app-side-menu>
